import React from 'react';
import { Tabs, Stack, Paper } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconUsers, IconUserCheck } from '@tabler/icons-react';
import WrappedCollaboratorTable from './CollaboratorTable';
import WrappedInternalCollaboratorTable from './InternalCollaboratorTable';
import classes from '../../HcpPatientDashboard/Graph/tab.module.css';

export type ITabbedCollaboratorViewProps = Record<string, never>;

const TabbedCollaboratorView: React.FC<ITabbedCollaboratorViewProps> = () => {
    const { t } = useTranslation();

    return (
        <Stack gap={0} h="100%" w="100%">
            <Tabs defaultValue="internals" classNames={classes}>
                <Tabs.List>
                    <Tabs.Tab 
                        value="internals" 
                        leftSection={<IconUserCheck size={16} />}
                    >
                        {t('collaborator.tabs.internals')}
                    </Tabs.Tab>
                    <Tabs.Tab 
                        value="externals" 
                        leftSection={<IconUsers size={16} />}
                    >
                        {t('collaborator.tabs.externals')}
                    </Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="internals">
                    <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                        <WrappedInternalCollaboratorTable />
                    </Paper>
                </Tabs.Panel>
                
                <Tabs.Panel value="externals">
                    <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                        <WrappedCollaboratorTable />
                    </Paper>
                </Tabs.Panel>
            </Tabs>
        </Stack>
    );
};

export default TabbedCollaboratorView;
